import React, { useState } from "react";
import './Header.css';
import logo from "../Asset/_Path_ (13).png";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../i18n/LocaleContext';
import LanguageSwitcher from './LanguageSwitcher';
import {FaBars, FaTimes } from 'react-icons/fa';
import sv from '../Asset/1.svg'
import sv2 from '../Asset/2.svg'
import sv3 from '../Asset/3.svg'
import sv5 from '../Asset/5.svg'
import sv4 from '../Asset/icons8-google-code.svg'
import sv6 from '../Asset/icons8-stackshare.svg'
import sv7 from '../Asset/icons8-cloud-development-100.png'
import sv8 from '../Asset/icons8-ethereum.svg'
import sv9 from '../Asset/5.svg'
const Header = () => {
  // State to track the clicked service
  const { t } = useTranslation();
  const { path } = useLocale();
  const [activeService, setActiveService] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prevState => !prevState);
  };
  const navigate = useNavigate();
  // Function to toggle active state for each service
  const handleServiceClick = (service) => {
    if (activeService === service) {
      setActiveService(null); // Close the active service
    } else {
      setActiveService(service); // Open the clicked service
    }
  };
 
  return (
    <header className="header">
      <div className="logo">
      <a onClick={() => navigate(path('/'))}><img src={logo} width={180} alt="Logo" /></a>
      </div>
      {/* Hamburger Menu Icon */}
      <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      <nav className={`nav ${menuOpen ? 'active' : ''}`}>
        <ul>
          <li className="services">
            <a id="a-service" href={path("/services")} onClick={(e) => e.preventDefault()}>{t('nav.services')} <svg fill="#ffffff" height="3vh" width="3vw" version="1.1" viewBox="0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)rotate(90)">
  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <g>
      <g>
        <path d="M440.082,249.209L220.747,3.409C218.812,1.24,216.044,0,213.137,0H79.527c-4.021,0-7.666,2.361-9.308,6.03 c-1.643,3.669-0.979,7.96,1.698,10.96L285.192,256L71.918,495.01c-2.677,3-3.341,7.291-1.698,10.96 c1.642,3.669,5.288,6.03,9.308,6.03h133.61c2.906,0,5.675-1.24,7.61-3.409l219.335-245.801 C443.535,258.921,443.535,253.079,440.082,249.209z M208.568,491.602H102.297l204.175-228.811c3.453-3.87,3.453-9.712,0-13.581 L102.297,20.398h106.271L418.802,256L208.568,491.602z"></path>
      </g>
    </g>
    <g>
      <g>
        <path d="M245.948,81.942l-6.37-7.139c-3.751-4.201-10.195-4.57-14.401-0.82c-4.202,3.751-4.57,10.198-0.82,14.401l6.37,7.139 c2.016,2.258,4.809,3.409,7.615,3.409c2.416,0,4.842-0.854,6.787-2.589C249.33,92.592,249.698,86.146,245.948,81.942z"></path>
      </g>
    </g>
    <g>
      <g>
        <path d="M395.204,249.209L269.61,108.46c-3.749-4.201-10.194-4.571-14.4-0.819c-4.202,3.75-4.57,10.197-0.819,14.4 l125.594,140.749c2.015,2.258,4.808,3.409,7.614,3.409c2.415,0,4.842-0.854,6.787-2.59 C398.587,259.859,398.955,253.412,395.204,249.209z"></path>
      </g>
    </g>
  </g>
</svg>
 </a>
            <div className="dropdown">
              {/* App Development Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("app-development")}
                  className={activeService === "app-development" ? "active" : ""}
                >
                  <a href={path("/services/app-development")}>{t('nav.appDevelopment')}</a>
                </h3>
                <ul className={activeService === "app-development" ? "active" : ""}>
                  <li><img src={sv2}/><a onClick={() => navigate("/android-development")}>{t('nav.androidApp')}</a></li>
                  <li><img src={sv3}/><a onClick={() => navigate("/iOS-development")}>{t('nav.iosApp')}</a></li>
                  <li><img src={sv}/><a onClick={() => navigate("/cross-platform-development")}>{t('nav.crossPlatform')}</a></li>
                  <li><img src={sv5}/><a onClick={() => navigate("/software-development")}>{t('nav.customSoftware')}</a></li>
                </ul>
              </div>

              {/* Web Applications Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("web-applications")}
                  className={activeService === "web-applications" ? "active" : ""}
                >
                  <a href={path("/services/web-applications")}>{t('nav.webApplications')}</a>
                </h3>
                <ul className={activeService === "web-applications" ? "active" : ""}>
                  <li><img src={sv6}/><a onClick={() => navigate('')}>{t('nav.customWebApps')}</a></li>
                  <li><img src={sv7}/><a href={path("/services/web-applications/progressive-web-apps")}>{t('nav.progressiveWebApps')}</a></li>
                  <li><img src={sv8}/><a href={path("/services/web-applications/custom-software")}>{t('nav.customSoftware')}</a></li>
                </ul>
              </div>

              {/* Product Engineering Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("product-engineering")}
                  className={activeService === "product-engineering" ? "active" : ""}
                >
                  <a href={path("/services/product-engineering")}>{t('nav.productEngineering')}</a>
                </h3>
                <ul className={activeService === "product-engineering" ? "active" : ""}>
                  <li><img src={sv5}/><a href={path("/services/product-engineering/saas")}>{t('nav.saas')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/product-engineering/lean-product")}>{t('nav.leanProduct')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/product-engineering/custom-application")}>{t('nav.customApplication')}</a></li>
                </ul>
              </div>

              {/* UI/UX Design Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("ui-ux-design")}
                  className={activeService === "ui-ux-design" ? "active" : ""}
                >
                  <a href={path("/services/ui-ux-design")}>{t('nav.uiUxDesign')}</a>
                </h3>
                <ul className={activeService === "ui-ux-design" ? "active" : ""}>
                  <li><img src={sv5}/><a href={path("/services/ui-ux-design/user-experience")}>{t('nav.userExperience')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/ui-ux-design/ui-design")}>{t('nav.uiDesign')}</a></li>
                </ul>
              </div>

              {/* Staff Augmentation Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("staff-augmentation")}
                  className={activeService === "staff-augmentation" ? "active" : ""}
                >
                  <a href={path("/services/staff-augmentation")}>{t('nav.staffAugmentation')}</a>
                </h3>
                <ul className={activeService === "staff-augmentation" ? "active" : ""}>
                  <li><img src={sv5}/><a href={path("/services/staff-augmentation/front-end-developer")}>{t('nav.frontEnd')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/staff-augmentation/back-end-developer")}>{t('nav.backEnd')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/staff-augmentation/mobile-app-developer")}>{t('nav.mobileDev')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/staff-augmentation/full-stack-developer")}>{t('nav.fullStack')}</a></li>
                </ul>
              </div>

              {/* Trending Technologies Section */}
              <div>
                <h3
                  onClick={() => handleServiceClick("trending-technologies")}
                  className={activeService === "trending-technologies" ? "active" : ""}
                >
                  <a href={path("/blockchain-development")}>{t('nav.web3Development')}</a>
                </h3>
                <ul className={activeService === "trending-technologies" ? "active" : ""}>
                  <li><img src={sv5}/><a href={path("/services/trending-technologies/iot-development")}>{t('nav.blockchain')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/trending-technologies/augmented-reality")}>{t('nav.smartContract')}</a></li>
                  <li><img src={sv5}/><a href={path("/services/trending-technologies/chatbot-development")}>{t('nav.dapp')}</a></li>
                </ul>
              </div>
            </div>
          </li>
          
          <li><a href={path("/company")}>{t('nav.company')}</a></li>
          <li><a href={path("/Projects")}>{t('nav.projects')}</a></li>
          <li className="services solutions-item">
            <a id="a-solutions" href={path("/solutions")} onClick={(e) => e.preventDefault()}>{t('nav.solutions')} <svg fill="#ffffff" height="3vh" width="3vw" version="1.1" viewBox="0 0 512 512" transform="matrix(1, 0, 0, 1, 0, 0)rotate(90)"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><g><g><path d="M440.082,249.209L220.747,3.409C218.812,1.24,216.044,0,213.137,0H79.527c-4.021,0-7.666,2.361-9.308,6.03 c-1.643,3.669-0.979,7.96,1.698,10.96L285.192,256L71.918,495.01c-2.677,3-3.341,7.291-1.698,10.96 c1.642,3.669,5.288,6.03,9.308,6.03h133.61c2.906,0,5.675-1.24,7.61-3.409l219.335-245.801 C443.535,258.921,443.535,253.079,440.082,249.209z"></path></g></g></g></svg></a>
            <div className="dropdown">
              <div>
                <h3><a href={path("/solutions/edtech")}>🎓 EdTech Platforms</a></h3>
                <ul>
                  <li><a href={path("/solutions/edtech")}>AI-Powered LMS</a></li>
                  <li><a href={path("/solutions/edtech")}>Intelligent Tutoring</a></li>
                  <li><a href={path("/solutions/edtech")}>Virtual Classrooms</a></li>
                </ul>
              </div>
              <div>
                <h3><a href={path("/solutions/hosting")}>🖥️ Hosting & Servers</a></h3>
                <ul>
                  <li><a href={path("/solutions/hosting")}>Cloud Hosting</a></li>
                  <li><a href={path("/solutions/hosting")}>Dedicated Servers</a></li>
                  <li><a href={path("/solutions/hosting")}>CDN & Edge Delivery</a></li>
                </ul>
              </div>
              <div>
                <h3><a href={path("/solutions/ai-training")}>🤖 AI Training & Dev</a></h3>
                <ul>
                  <li><a href={path("/solutions/ai-training")}>Custom LLM Training</a></li>
                  <li><a href={path("/solutions/ai-training")}>MLOps & Infrastructure</a></li>
                  <li><a href={path("/solutions/ai-training")}>NLP & Computer Vision</a></li>
                </ul>
              </div>
            </div>
          </li>
           {/* Services Link on Mobile */}
           <li className="services-mobile">
            <a href="#Services-Section">{t('nav.services')}</a>
          </li>
          <li><a href={path("/shop")}>{t('nav.shop')}</a></li>
          <li><a href={path("/blogs")}>{t('nav.thinking')}</a></li>
          <li id="contact"><a href={path("/contact")}>{t('nav.contact')}</a></li>
          <li className="nav-lang"><LanguageSwitcher /></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
